import styled from 'styled-components'

export const InputContainer = styled.div`
  margin-bottom: ${props => props.mb || '1rem'};
  width: 100%;
`

export const InputLabel = styled.div`
  margin-bottom: 0.5rem;
`

export const StyledTextField = styled.div`
  .MuiOutlinedInput-root {
    background-color: ${props =>
      props.theme.colors?.background?.paper || '#fff'};

    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${props =>
          props.theme.colors?.primary?.main || '#1976d2'};
      }
    }

    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${props =>
          props.theme.colors?.primary?.main || '#1976d2'};
        border-width: 2px;
      }
    }
  }

  .MuiFormHelperText-root {
    margin-left: 0;
    margin-top: 4px;
  }
`
